var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { MathUtils } from '@printu/geom';
import { getItemBounds } from 'app/core/markers/bounds';
import { is } from 'app/core/markers/models';
import { applyCrop } from 'app/utils/geom';
import { projectSlice } from '../project';
import { getImage, getMarker } from '../selectors';
export const cropImageMarker = createAsyncThunk('project/marker/crop-image', (params, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const { id, crop } = params;
    const state = getState();
    const marker = getMarker(state, id);
    if (!is(marker, 'Image')) {
        return;
    }
    const image = getImage(state, marker.image);
    if (!image) {
        return;
    }
    const cropedBounds = applyCrop({ x: 0, y: 0, width: image.size.width, height: image.size.height }, crop);
    const markerBounds = getItemBounds(marker);
    const fitSize = MathUtils.getFitSize(cropedBounds.width, cropedBounds.height, markerBounds.width, markerBounds.height);
    dispatch(projectSlice.actions.itemUpdate({
        id: marker.id,
        patch: {
            crop,
            endX: fitSize.width,
            endY: fitSize.height,
        },
    }));
}));
